import gql from "graphql-tag";
import RankedIssuerFields from "lib/fragments/RankedIssuerFields";
import YearlyBrazilianCompanyFinancialsFields from "lib/fragments/YearlyBrazilianCompanyFinancialsFields";
import YouTubeVideoFields from "lib/fragments/YouTubeVideoFields";
import TrailingReturnsFields from "lib/graphql/fragments/TrailingReturnsFields";

export default gql`
  fragment BrazilianCompanyIssuerTopLevel on BrazilianCompanyIssuer {
    _id
    cvmCode
    cnpj
    name
    listingSegment
    tickerSymbolPrefix
    isInChapter11
    isUnderTenderOffer
    isInPortfolio
    viewerDidBookmark
    isBrazilianDepositaryReceipt
    engagementStats {
      totalDiscussionsCommentsCount
      viewerUnseenDiscussionsCommentsCount
    }
    tagAlong {
      commonStock
      preferredStock
      unitStock
    }
    standardLogo {
      url
      geometry
      dominantColor
      colorPalette
    }
    niceLogo {
      url
      geometry
      dominantColor
      colorPalette
    }
    securities {
      _id
      name
      type
      tickerSymbol
      sharesOutstanding
      isin
      corporateGovernanceLevel
      hasQuotes
      depositoryReceiptRatio
      trailingReturns {
        ...TrailingReturnsFields
      }
      liquidityScore {
        calculatedScore
        tickerSymbol
      }
    }
    fiscalYearEnd {
      day
      month
    }
    dateOfIncorporation
    businessDescription
    website
    reclameAquiUrl
    investorRelationsUrl
    riskFactorsUrl
    briefHistoryUrl
    operatingSegmentsUrl
    ownershipStructureUrl
    descriptionOfActivitiesUrl
    lastYearlyManagementReport {
      dateOfReference
      deliveryDate
      pdfURL
    }
    lastQuarterlyManagementReport {
      dateOfReference
      deliveryDate
      pdfURL
    }
    sector
    headquarters {
      street
      city
      neighborhood
      state
      postalCode
      country
    }
    auditor {
      cvmCode
      name
      dateSince
    }
    bookkeeper
    reclameAquiRatings {
      reclameAquiUrl
      asOfDate
      finalScore
      classification
    }
    positionOfShareholders {
      ...BrazilianCompanyIssuerShareholderFields
      ...BrazilianCompanyIssuerSharesTotalFields
    }
    majorityShareholders {
      ...BrazilianCompanyIssuerShareholderFields
      ...BrazilianCompanyIssuerSharesTotalFields
    }
    officers {
      ...BrazilianCompanyIssuerOfficerFields
    }
    chiefExecutiveOfficer {
      ...BrazilianCompanyIssuerOfficerFields
    }
    freeFloat {
      ...BrazilianCompanyIssuerSharesTotalFields
    }
    treasuryShares {
      ...BrazilianCompanyIssuerSharesTotalFields
    }
    marketCapitalization(tickerSymbol: $tickerSymbol) {
      totalCapitalization
      asOfDate
    }
    employeeNumbers {
      totalOfEmployees
      asOfDate
    }
    foundedYear
    headquarters {
      street
      city
      neighborhood
      state
      postalCode
      country
    }
    youtubeVideos {
      ...YouTubeVideoFields
    }
    financials {
      yearly {
        ...YearlyBrazilianCompanyFinancialsFields
      }
    }
    subsidiaries {
      _id
      name
      sector
      tickerSymbolPrefix
      primaryTickerSymbol
      niceLogo {
        url
        geometry
        dominantColor
        colorPalette
      }
    }
    nextUpcomingCalendarEvent {
      eventDate
      eventType

      ... on EarningsResultsEvent {
        eventFiscalYear
      }
    }
    b3IndexParticipation(marketIndexSymbol: "IBOV", maturity: QUARTER) {
      marketIndex {
        tickerSymbol
        name
        validSince
        validUntil
      }
      stockParticipationPercent
      components {
        tickerSymbol
        theoreticalQuantity
        stockParticipationPercent
      }
    }
    liquidityScore {
      calculatedScore
      tickerSymbol
    }
    ...RankedIssuerFields
    cvmRegistrationDate
  }

  ${RankedIssuerFields}
  ${YearlyBrazilianCompanyFinancialsFields}
  ${YouTubeVideoFields}
  ${TrailingReturnsFields}

  fragment BrazilianCompanyIssuerShareholderFields on BrazilianCompanyIssuerShareholderPosition {
    type
    name
    nationality
    isControllingShareholder
    isGovernmentOrGovernmentRelated
  }

  fragment BrazilianCompanyIssuerSharesTotalFields on BrazilianCompanyIssuerSharesTotal {
    totalShares
    totalSharesOfCommonStock
    totalSharesOfPreferredStock
    percentageOfTotalShares
    percentageOfTotalSharesOfCommonStock
    percentageOfTotalSharesOfPreferredStock
  }

  fragment BrazilianCompanyIssuerOfficerFields on BrazilianCompanyIssuerOfficer {
    board
    name
    occupation
    ellectedByControllingShareholder
    electedDate
    effective
    numberOfConsecutiveTerms
    position
    otherPositionOrDuties
    dateOfBirth
    termOfOffice
  }
`;
